import { render, staticRenderFns } from "./ClientPerformance.vue?vue&type=template&id=726d08ee&scoped=true&"
import script from "./ClientPerformance.vue?vue&type=script&lang=js&"
export * from "./ClientPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726d08ee",
  null
  
)

export default component.exports